var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavori(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.7 30",
    style: {
      enableBackground: "new 0 0 33.7 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,30c-0.5,0-0.9-0.2-1.3-0.5c-1.4-1.2-2.7-2.3-3.8-3.3l0,0c-3.4-2.9-6.3-5.4-8.4-7.8C1.1,15.6,0,13,0,10.1 C0,7.4,0.9,4.8,2.7,3C4.4,1.1,6.8,0,9.4,0c1.9,0,3.8,0.6,5.3,1.8c0.8,0.6,1.5,1.4,2.1,2.2c0.6-0.8,1.3-1.6,2.1-2.2 C20.5,0.7,22.3,0,24.3,0c2.6,0,5,1,6.7,2.9c1.7,1.9,2.7,4.4,2.7,7.2c0,2.8-1.1,5.5-3.3,8.2c-2,2.5-5,5-8.4,7.8 c-1.2,1-2.5,2.1-3.8,3.3C17.8,29.8,17.3,30,16.8,30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavori);
export default __webpack_public_path__ + "static/media/favori.a7b3ef60c284eeabfcbf93fb64516de9.svg";
export { ForwardRef as ReactComponent };